export const GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_ABORTED =
  'GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_ABORTED';
export const GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_REQUESTED =
  'GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_REQUESTED';
export const GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_COMPLETED =
  'GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_COMPLETED';
export const GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_FAILED =
  'GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_FAILED';
